import React from 'react';

type IconCloseProps = {
    className?: string;
};

export function IconClose(props: IconCloseProps) {
    const { className = '' } = props;

    return (
        <svg className={`${className}`} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path stroke="#000000" d="M11 5L5 11" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path stroke="#000000" d="M5 5L11 11" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default IconClose;
